import React, { useState } from 'react';
import { gql } from '@apollo/client';
import { Datagrid, FunctionField, List, TextField, useNotify, useRefresh } from 'react-admin';
import { Box, Button } from '@mui/material';
import { IdFilter } from 'components/Filter';
import IdField from 'components/IdField';
import PoolCreateEditModal from './PoolCreateEditModal';
import { formatSpecialtiesLabel } from './specialtiesDisplay.utils';

const poolsFilters = [
  <IdFilter />,
  <IdFilter label="Location ID" source="search.location_id" alwaysOn />,
];

const ProPoolsList = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSuccess = () => {
    setIsModalOpen(false);
    notify('Pool created successfully', { type: 'success' });
    refresh();
  };

  return (
    <List exporter={false} filters={poolsFilters}>
      <>
        <Box mb={2}>
          <Button variant="contained" size="small" onClick={() => setIsModalOpen(true)}>
            Create Pool
          </Button>
        </Box>
        <Datagrid bulkActionButtons={false}>
          <IdField />
          <TextField label="Location" source="location.id" sortable={false} />
          <FunctionField
            label="Position(s)"
            sortBy="position"
            render={(record) => record?.positions?.map((item) => item.display_name).join(', ')}
          />
          <FunctionField
            label="Specialties"
            render={(record) => formatSpecialtiesLabel(record?.specialties)}
          />
          <TextField
            label="Invites Pending"
            source="onboarding_status.not_accepted"
            sortable={false}
          />
          <TextField
            label="Ready for Review"
            source="onboarding_status.ready_for_review"
            sortable={false}
          />
          <TextField
            label="Pros in Credentialing"
            source="onboarding_status.credentialing"
            sortable={false}
          />
          <TextField
            label="W2 Payroll Setup"
            source="onboarding_status.w2_payroll_setup"
            sortable={false}
          />
          <TextField
            label="Pros in Onboarding"
            source="onboarding_status.orientation"
            sortable={false}
          />
          <TextField
            label="Pros Ready to Work"
            source="onboarding_status.complete"
            sortable={false}
          />
        </Datagrid>
        <PoolCreateEditModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSuccess={handleSuccess}
        />
      </>
    </List>
  );
};

ProPoolsList.query = gql`
  query GET_LIST($input: PoolQueryInput!) {
    pools(input: $input) {
      id
      location {
        id
      }
      positions {
        display_name
      }
      specialties {
        label
      }
      onboarding_status {
        not_accepted
        ready_for_review
        credentialing
        w2_payroll_setup
        orientation
        complete
      }
    }
    _poolsMeta(input: $input) {
      count
    }
  }
`;

export default ProPoolsList;
